import s from '@/styles/components/Tab.module.scss'
import { ForwardedRef, forwardRef, HTMLAttributes, PropsWithChildren } from 'react'
import { classNames } from '@tmap-web-lib/utils'

// type TabsVariant = 'default' | 'segment' | 'capsule'
type SegmentAppearance = 'padded' | 'outlined'

type TabsCommon = PropsWithChildren<HTMLAttributes<HTMLDivElement>>

/** default에서만 scrollable 허용 */
type TabsDefault = {
  variant?: 'default';
  scrollable?: boolean;
  appearance?: never; // default는 appearance 사용 불가
}

/** segment에서만 appearance 허용, scrollable 금지 */
type TabsSegment = {
  variant: 'segment';
  appearance?: SegmentAppearance;
  scrollable?: never;
}

/** capsule에서는 appearance 불가 */
type TabsCapsule = {
  variant: 'capsule';
  appearance?: never;
  scrollable?: never;
}

type TabsProps = TabsCommon & (TabsDefault | TabsSegment | TabsCapsule)

const Tabs = forwardRef((props: TabsProps, ref?: ForwardedRef<HTMLUListElement>) => {
  const {
    variant = 'default',
    children,
    appearance,
    scrollable,
    ...attr
  } = props

  return (
    <div
      className={classNames(
        s.tabs,
        s[variant],
        appearance ? s[appearance] : undefined,
        scrollable ? s.scrollable : undefined,
        attr.className,
      )}
    >
      <ul ref={ref} className={s.tray}>
        {children}
      </ul>
    </div>
  )
})

Tabs.displayName = 'Tabs'
export { Tabs }
